export default {
  SET_BANK_CASHFLOW (state, bankCashflow) {
    state.bankCashflow = bankCashflow
  },
  REMOVE_RECORD (state, itemId) {
    const bankCashflowIndex = state.bankCashflow.findIndex((u) => u.id === itemId)
    state.bankCashflow.splice(bankCashflowIndex, 1)
  }
}
